import { createSlice } from "@reduxjs/toolkit";
import { ProductCategory } from "@utils/constants";
import { useSelector } from "react-redux";

interface UnifiedProductPagesState {
  [key: string]: any;
  updatedTime?: string;
}

const initialState: UnifiedProductPagesState = {};

const unifiedProductPagesSlice = createSlice({
  name: "unifiedProductPages",
  initialState,
  reducers: {
    setUnifiedProductPages: (state, action) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(),
      };
    },
    clearUnifiedProductPagesData: (state) => {
      state.unifiedProductPages = initialState;
    },
  },
});

export const getShareOptionMenu = (
  state: any,
  productType: ProductCategory
) => {
  const unifiedProductPages = state.unifiedProductPages;
  if (
    unifiedProductPages &&
    typeof unifiedProductPages?.[productType]?.share_menu_options ===
      "object" &&
    unifiedProductPages?.[productType]?.share_menu_options !== null
  ) {
    return unifiedProductPages?.[productType]?.share_menu_options;
  }
  return {};
};

export const getScreenWiseShareOptionMenu = (
  state: any,
  productType: ProductCategory,
  screenName: string
) => {
  const unifiedProductPages = state.unifiedProductPages;
  if (
    unifiedProductPages &&
    typeof unifiedProductPages?.[productType]?.[screenName]
      ?.share_menu_options === "object" &&
    unifiedProductPages?.[productType]?.[screenName]?.share_menu_options !==
      null
  ) {
    return unifiedProductPages?.[productType]?.[screenName]?.share_menu_options;
  } else if (
    unifiedProductPages &&
    typeof unifiedProductPages?.[productType]?.share_menu_options ===
      "object" &&
    unifiedProductPages?.[productType]?.share_menu_options !== null
  ) {
    return unifiedProductPages?.[productType]?.share_menu_options;
  }
  return {};
};

export const { setUnifiedProductPages } = unifiedProductPagesSlice.actions;

export const { clearUnifiedProductPagesData } =
  unifiedProductPagesSlice.actions;

export default unifiedProductPagesSlice.reducer;

export const getUnifiedProductPages = (state: any) => state.unifiedProductPages;

export const useUnifiedProductPages = () => {
  return useSelector(getUnifiedProductPages);
};

export const useUnifiedProductPagesSlice = () => {
  const unifiedProductData = useSelector(
    (state: any) => state.unifiedProductPages
  );

  return {
    unifiedProductData,
  };
};

export const useShareOptionConfig = (productType: ProductCategory) => {
  return useSelector((state) => getShareOptionMenu(state, productType));
};

export const useScreenWiseShareOptionConfig = (
  productType: ProductCategory,
  screenName: string
) => {
  return useSelector((state) =>
    getScreenWiseShareOptionMenu(state, productType, screenName)
  );
};
